export default "__VITE_ASSET__Dim25WXJ__"